<template>
	<div class="d-flex flex-column result-display">
		<div class="sortition-name text-center" :class="white ? 'white-text' : 'green-text'">
			{{ result.sortition.name }}
		</div>
		<div class="sortition-date text-center" :class="white ? 'white-text' : 'green-text'">{{ result.date }}</div>
		<v-row no-gutters>
			<v-col md="6" lg="6" class="align-self-center border-right">
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.first"
							text="1st"
							left
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.second"
							text="2nd"
							left
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.third"
							text="3rd"
							left
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
			</v-col>
			<v-col md="6" lg="6">
        <v-row no-gutters v-if="result.pickTwo">
					<v-col cols="12">
						<v-img height="30" contain :src="getPickImage('pick2')"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickTwo"
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="getPickImage('pick3')"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.cashThree"
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="getPickImage('pick4')"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickFour"
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row v-if="result.pickFive" no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="getPickImage('pick5')"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickFive"
							:color="getColor()"
						></result-digit-display>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import ResultDigitDisplay from './ResultDigitDisplay.vue';
	import pick2 from './images/pick2.png';
	import pick3 from './images/pick3.png';
	import pick4 from './images/pick4.png';
	import pick5 from './images/pick5.png';
	import pick2Green from './images/pick2_g.png';
	import pick3Green from './images/pick3_g.png';
	import pick4Green from './images/pick4_g.png';
	import pick5Green from './images/pick5_g.png';

	export default {
		name: 'ResultDisplay',
		components: { ResultDigitDisplay },
		props: {
			result: {
				type: Object,
				required: true
			},
			white: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			getPickImage(pick) {
				switch (pick) {
					case 'pick2':
						if (this.white) {
							return pick2;
						}
						return pick2Green;
					case 'pick3':
						if (this.white) {
							return pick3;
						}
						return pick3Green;
					case 'pick4':
						if (this.white) {
							return pick4;
						}
						return pick4Green;
					case 'pick5':
						if (this.white) {
							return pick5;
						}
						return pick5Green;
				}
			},
			getColor() {
				if (this.white) {
					return 'white-text';
				}
				return 'green-text';
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "css/variables";

	.sortition-name {
		line-height: 20px;
		font-size: 1.3rem;
		font-weight: bold;
	}
	.green-text {
		color: $green;
	}

	.text-yellow {
		color: white;
	}

	.next-drawing-text {
		color: white;
	}

	.sortition-date {
		font-size: 1rem;
	}

	.first,
	.second,
	.third {
		display: flex;
		flex-direction: column;
		margin-top: 0;

		.header {
			line-height: 35px;
			text-align: center;
		}
	}

	.border-right {
		padding-right: 15px;
		border-right: $yellow solid 5px;
	}
</style>
